<template>
  <div class="notice_banner_recommend" v-if="bannerList.length > 0 && isKeep">
    <mySwiper
      ref="notice_banner_swiper"
      :loop="bannerList.length > 1 ? true : false"
      :slidesNum="1"
      :autoplay="bannerList.length > 1 ? true : false"
      :autoplayNumber="3000"
      :allowTouchMove="false"
      direction="vertical"
      :paginationFlag="false"
      :centeredSlides="true"
      swipeid="notice_banner_swiper"
      @slideChange="slideChange"
    >
      <div
        class="swiper-slide"
        slot="swiper-con"
        v-for="(banner, index) in bannerList"
        :data="
          JSON.stringify({
            xmhh5_home_banner_url: banner.skipUrl,
            banner_station: index + 1,
          })
        "
        :key="banner.id"
        @click.stop="toBannerLink(banner, index)"
      >
        <!-- 安卓手机，并且url为外链 -->
        <template v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.skipUrl)">
          <a
            v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.skipUrl)"
            @click="goBannerLink(banner, index)"
          >
            <p class="notice-item">
              <img
                src="../../assets/images/community/noticeIcon.png"
                alt="通知"
              />
              <span>{{ banner.content }}</span>
            </p>
          </a>
        </template>
        <p class="notice-item" v-else>
          <img src="../../assets/images/community/noticeIcon.png" alt="通知" />
          <span>{{ banner.content }}</span>
        </p>
      </div>
    </mySwiper>
    <template v-for="(banner, index) in bannerList">
      <div
        class="hometagWrap"
        v-if="!/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.skipUrl)"
        :key="banner.imgUrl"
        v-show="activeIndex == index"
      >
        <openWxTag
          :id="'noticeBanner' + banner.id"
          :path="banner.skipUrl"
          btnStyle="width:100%;height:40px"
          @sensorsFn="toBannerLink(banner, index)"
        ></openWxTag>
      </div>
    </template>
  </div>
</template>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue"; //轮播图
import { goToMini, TestUserAgent, Debounce } from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";
import { BuiedPointClick_Fn, Exposurer_Fn } from "@/assets/js/BuriedPointEvent";
// import { home_banner_export } from "@/assets/js/Exposure";
export default {
  name: "homeBanner",
  data() {
    return {
      bannerList: [], //banner列表
      UserInfo: null,
      unionid: "",
      isSystem: "",
      activeIndex: 0,
      sensorsIndex: 0,
      isKeep: false,
    };
  },
  components: { mySwiper, openWxTag },
  activated() {
    this.isKeep = true;
  },
  deactivated() {
    this.isKeep = false;
  },
  mounted() {
    this.getBannerList();
    this.isSystem = TestUserAgent().isios;
  },
  methods: {
    DebounceGoToMini: Debounce(function (id, link) {
      console.log(id, link);
      goToMini(id, link);
    }),
    slideChange(index) {
      this.sensorsIndex = this.sensorsIndex + 1;
      this.activeIndex = index == this.bannerList.length + 1 ? 0 : index - 1;
      if (this.sensorsIndex <= this.bannerList.length) {
        sensors.track("xmhh5CommunityExpo", {
          xmhh5_Community_Notice_Expo:
            this.bannerList[this.activeIndex].content,
        });
      }
    },
    // 获取banner列表
    getBannerList() {
      this.$http.get(
        "/bulletin/list",
        { moduleType: 1 },
        (res) => {
          if (res.code === 200) {
            this.bannerList = res.data || [];
            this.$nextTick(() => {
              this.isKeep = true;
              // Exposurer_Fn.observe("xmhh5_home_banner_view",".swiper-slide", false)
            });
          }
        },
        (err) => {
          console.log(err);
        },
        "lucky"
      );
    },
    // banner点击
    toBannerLink(item, index) {
        BuiedPointClick_Fn("xmhh5CommunityNoticeClick", {
          xmhh5_Community_Notice_title: item.content,
          xmhh5_Community_Notice_position: index + 1,
        });
    },
    goBannerLink(banner, index) {
      setTimeout(() => {
        location.href = banner.skipUrl;
      }, 3000);
    },
  },
};
</script>

<style lang="less" scoped>
.notice_banner_recommend {
  position: relative;
  // background: #ffffff;
  /deep/.mySwiper .swiper-container {
    height: 40px;
    overflow: hidden !important;
    padding-bottom: 0 !important;
    .swiper-wrapper {
      .swiper-slide {
        height: 40px;
        border-radius: 6px;
        a {
          width: 100%;
          height: 100%;
          display: block;
        }
        .notice-item {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0;
          img {
            width: 12px;
            height: auto;
            margin-right: 8px;
          }
          span {
            font-size: 12px;
            line-height: 40px;
            color: #999999;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
    //
    .swiper-pagination-clickable {
      text-align: center;
      width: 100%;
      .swiper-pagination-bullet {
        width: 5px;
        height: 5px;
        // background: #FFFFFF;
        border-radius: 50%;
        opacity: 0.5;
        margin: 0 3px;
        &.swiper-pagination-bullet-active {
          border-radius: 6px;
          width: 10px;
          opacity: 1;
        }
      }
    }
  }
  .hometagWrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    z-index: 999;
    a {
      display: block;
      width: 100%;
      height: 40px;
    }
  }
}
</style>
